import { render } from "./E404.vue?vue&type=template&id=e639d38e"
import script from "./E404.vue?vue&type=script&lang=js"
export * from "./E404.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__